export default __webpack_public_path__ + "static/media/icon_expanded.49634505.svg";